import React from 'react';

// ReaperCast logo — reaper blade + radio wave + forge spark.
// Parent brand: the music-career OS. VidCreForge is an included product.
export default function Logo({ size = 'md', mono = false, showTagline = false }) {
  const dim = size === 'lg' ? 42 : size === 'sm' ? 24 : 34;
  return (
    <div className="flex items-center gap-2 select-none" data-testid="app-logo">
      <div className="relative" style={{ width: dim, height: dim }}>
        <div className="absolute inset-0 rounded-[10px]"
             style={{ background: mono ? '#fff' : 'linear-gradient(135deg,#a78bfa 0%,#ff2e63 50%,#ff7a00 100%)' }} />
        {!mono && <div className="absolute -top-0.5 -right-0.5 w-1.5 h-1.5 rounded-full" style={{ background: '#ffe58a', boxShadow: '0 0 6px #ffcf52' }} />}
        <div className="absolute inset-0 flex items-center justify-center">
          <svg width={Math.round(dim * 0.64)} height={Math.round(dim * 0.64)} viewBox="0 0 24 24" fill="none">
            {/* Reaper blade — scythe-ish arc */}
            <path d="M4 17c1.6-7 6.4-12 14-13.5-0.5 2.5-2.5 5-5 6.5" stroke={mono ? '#0a0a0c' : '#fff'} strokeWidth="2.2" strokeLinecap="round" fill="none" />
            {/* Radio signal arcs */}
            <path d="M6 19c3-4 7-6 12-6" stroke={mono ? '#0a0a0c' : '#fff'} strokeWidth="1.6" strokeLinecap="round" opacity="0.85" fill="none" />
            {/* Tip node */}
            <circle cx="5.5" cy="18" r="1.6" fill={mono ? '#0a0a0c' : '#fff'} />
          </svg>
        </div>
      </div>
      <div className="leading-none">
        <span className="font-display text-white text-[19px] tracking-[0.02em] font-black" style={{ lineHeight: 1 }}>
          <span className="brand-gradient">Reaper</span><span style={{ color: '#fff' }}>Cast</span>
        </span>
        {showTagline && (
          <div className="text-[9.5px] uppercase tracking-[0.2em] text-white/50 mt-1">The music career OS</div>
        )}
      </div>
    </div>
  );
}
